import { selectExperiments } from './experiments';
import { MOBWEB_ABC_ACTION_BUTTTON } from '../../constants/config';
import { IApplicationState } from '../../types/redux';
import { getAbUseExperiment } from '../../utils/experiments/getAbUseExperiment';

export const selectABCActionButtonExpGroup = (state: IApplicationState): 'A' | 'B' | 'C' | undefined => {
  const experiments = selectExperiments(state);

  const experiment = getAbUseExperiment(experiments, MOBWEB_ABC_ACTION_BUTTTON);

  return experiment?.groupName as 'A' | 'B' | 'C' | undefined;
};
